// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"92c0c8d2","413":"5e0f9914","577":"f7becae3","952":"f5de3813"}[chunkId] + ".chunk.js";
};